import React, { useState, useEffect } from 'react';
import '../../styles/dashboardPagesStyle/Charts.css';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { Info } from 'lucide-react';
import { EstoquePorTipo } from '../../API/dashboardDetailsService';


interface ProdutoDataItem {
  name: string;
  value: number;
}

interface ProdutoDashboardProps {
  planosSelecionados: string[];
  dadosEstoque: EstoquePorTipo;
}


const cores: string[] = ['#29306A', '#F55EEB', '#32BEF0', '#1323AD', '#2A86E3', '#B0E5FF', '#A52ABD'];

const renderCustomizedLabel = (props: any) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, outerRadius, percent } = props;
  
  const radius = outerRadius + 20; 
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y + 2}
      fill="#29306A"
      fontWeight="bold"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
      fontSize={12}
    >
      {`${(percent * 100).toFixed(1)}%`}
    </text>
  );
};

export default function ProdutoDashboard({ planosSelecionados, dadosEstoque }: ProdutoDashboardProps) {
  const [popup, setPopup] = useState<{ visible: boolean; text: string }>({
    visible: false,
    text: '',
  });

  const todosProdutos: ProdutoDataItem[] = [
    { name: 'Lote', value: dadosEstoque.Lote },
    { name: 'Apartamento', value: dadosEstoque.Apartamento },
    { name: 'Casa', value: dadosEstoque.Casa },
    { name: 'Comercial', value: dadosEstoque.Comercial },
    { name: 'Compacto', value: dadosEstoque.Compacto },
  ];

  // Função para filtrar produtos de acordo com o plano
  const produtoFiltrado = todosProdutos.filter(produto => {
    if (produto.name === 'Apartamento' || produto.name === 'Casa') {
      return planosSelecionados.includes('casa_apartamento');
    }
    if (produto.name === 'Compacto') return planosSelecionados.includes('compacto');
    if (produto.name === 'Comercial') return planosSelecionados.includes('comercial');
    if (produto.name === 'Lote') return planosSelecionados.includes('lote');
    return false;
  });

  const handleInfoClick = () => {
    setPopup({
      visible: true,
      text: 'Este gráfico mostra a distribuição do estoque por tipo de produto, com porcentagem de cada categoria em relação ao total.',
    });
  };

  const fecharPopup = () => setPopup({ visible: false, text: '' });

  return (
    <div className="card-grafico-produto info-card">
      <h3>Estoque por tipo de produto</h3>
      <Info className="info-btn" size={20} onClick={handleInfoClick} />

      <ResponsiveContainer width="100%" height={220}>
        <PieChart>
          <Pie
            data={produtoFiltrado}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={40}
            outerRadius={60}
            labelLine={true}
            label={renderCustomizedLabel}
          >
            {produtoFiltrado.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={cores[index % cores.length]} />
            ))}
          </Pie>
          <Legend verticalAlign="bottom" height={30} iconType="circle" />
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>

      {popup.visible && (
        <div className="info-popup-overlay" onClick={fecharPopup}>
          <div className="info-popup" onClick={e => e.stopPropagation()}>
            <h4>Informações</h4>
            <p>{popup.text}</p>
            <button onClick={fecharPopup}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
}
